import * as yup from "yup";
import { Category } from "../types/categories";

const noteSchema = yup.object().shape({
    title: yup.string().required("Escriba el título de la nota."),
    published: yup.number(),
    categories: yup.array<Category>()
    .test("atLeastOne", "Elija al menos una categoría,", (value) => value && value.length > 0), // yup.number().moreThan(0,"Seleccione una categoría.").required("Seleccione una categoría."),
    image: yup
      .number()
      .moreThan(0, "Selecciona una imagen")
      .required("Seleccione una imagen."),
    excerpt: yup.string().required("Este campo es requerido."),
    isOtherAuthor: yup.boolean(),
    author: yup.number().when('isOtherAuthor', {
        is: true,
        then: (_) => yup.number().moreThan(0, "Seleccione un autor").required('Este campo es requerido.'),
    }),
    scheduledAt: yup.string(),
    slug: yup.string(),
  });

export {
    noteSchema
}